import Notification from "element-ui/lib/notification.js";
import SharedWorker from "../../scripts/workers-loader.js!worker-loader?worker=SharedWorker!../sharedWorker";
import WebWorker from "../../scripts/workers-loader.js!worker-loader!../sharedWorker/indexWorker.js";

function onMessageWorker(evt) {
  const msg = evt.data;
  const cmd = msg.cmd;

  if (cmd === "error") {
    console.debug(msg);
    return;
  }

  if (["connected", "disconnected"].includes(cmd)) {
    console.info(msg.data.msg);
    globalThis.Siggma.ws.isConnected = msg.data.connected === true;
    return;
  }

  if (cmd === "session-another-location") {
    globalThis.Siggma.lockedSession(msg.data.message);
    return;
  }

  if (cmd === "access-control-granted") {
    const janelaDes = globalThis.Yanda.ctr.janelaDes;
    if (janelaDes?.uniqid === msg.data.uniqid) {
      msg.data.motivo && (janelaDes.$("motivo").value = msg.data.motivo);
      janelaDes.usuario = msg.data.usuario;
      if (msg.data.sessionUuid) {
        janelaDes.liberado();
      } else {
        janelaDes.$("pwd").value = msg.data.pwd;
        janelaDes.$("btnLiberar").click();
      }
    }
    return;
  }

  if (cmd === "cache-clear") {
    globalThis.Yanda.cache.clear()
      .then(() => console.log("cache limpo com sucesso"));
    return;
  }

  if (cmd === "force-reload") {
    globalThis.onbeforeunload = null;
    globalThis.location.reload();
    return;
  }

  if (cmd === "bind") {
    (msg.data.widgets !== undefined) &&
      globalThis.Siggma.$widgets?.load?.(msg.data.widgets || []);
    globalThis.Siggma.notify.setData(msg.data.notify);
    globalThis.Siggma.atualizacoes(msg.data.atualizacoes);

    const clear = msg.data.systemCacheClear;
    clear && parseInt(Storage.getItem("SystemCacheClear") || "0") < clear &&
      globalThis.Yanda.cache.clear().then(() => {
        Storage.setItem("SystemCacheClear", clear);
      });

    return;
  }

  if (cmd === "widgets-refresh") {
    globalThis.Siggma.$widgets?.refresh?.(msg.data);
    return;
  }

  if (cmd === "direct") {
    direct(msg.data);
    return;
  }
}

function direct(data) {
  const params = data.params || {};
  const { empresa, filial } = globalThis.Siggma;

  if (params.empresa != empresa) {
    return;
  }

  params.sound &&
    (new Audio(`${globalThis.Siggma.basePath}/sounds/question.wav`)).play();

  const n = Notification.info({
    title: data.title,
    message: data.message,
    dangerouslyUseHTMLString: true,
    duration: 0,
    offset: 50,
    onClick() {
      (params.tela && params.empresa == empresa && params.filial == filial) &&
        globalThis.Yanda.newApl(params.tela, params);
      n.close();
    },
  });
}

function sharedWorker() {
  const prefix = globalThis.Yanda.prefix.replace(":", "");

  if ("SharedWorker" in globalThis) {
    const worker = new SharedWorker(`${prefix}-core`);
    worker.onerror = (event) => console.error("shared-worker", event);
    worker.port.start();
    worker.port.addEventListener("message", onMessageWorker);

    return worker;
  }

  if (!("Worker" in globalThis)) {
    console.error("No suport for Workers");
    return;
  }

  console.info("No suport for SharedWorkers, using normal Worker");

  const ww = new WebWorker(`${prefix}-core`);
  ww.onerror = (event) => console.error("web-worker", event);

  const worker = { port: ww };
  worker.port.addEventListener("message", onMessageWorker);

  return worker;
}

export default sharedWorker;
